import React from "react";
import { Modal } from "react-bootstrap";
import styles from "../../_css/DeleteUserModal.module.css";
import { useSelector } from "react-redux";

const VideoPlayer = ({ show, onHide, videoLink }) => {
  const lang = useSelector((state) => state.language.lang);
  const title = {
    en: "Watch Video",
    ar: "مشاهدة الفيديو",
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={styles.endSessionModal}
      size="lg"
    >
      <Modal.Header className={" p-3 py-2"} closeButton>
        <Modal.Title
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "var(--color-1)",
          }}
        >
          {title[lang]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="flex justify-center">
          <iframe
            src={videoLink}
            width="100%"
            height="360"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Vimeo video"
            className=""
          ></iframe>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VideoPlayer;
